/* Owns the custom review list: replaces Klaviyo's filter pills with a Sort by
   dropdown, renders a configurable initial number of reviews (PAGE_SIZE), and
   appends more via a "Show more" button. All rendering calls the same Klaviyo
   client_reviews API the widget itself uses, emitting markup that matches
   Klaviyo's class names so klaviyo-reviews.css applies unchanged. */
(function () {
  var COMPANY_ID = 'SUKwtm';
  /* Klaviyo's client_reviews API sort values (verified empirically against
     phoebe-pullover): 1 = highest rating first (5→1), 2 = lowest rating
     first (1→5), 3 = most recent (date desc). Values 4 and 5 return empty. */
  var DEFAULT_SORT = '1';
  var SORT_OPTIONS = [
    { value: '1', label: 'Highest rating' },
    { value: '2', label: 'Lowest rating' },
    { value: '3', label: 'Most recent' }
  ];
  /* Initial number of reviews shown before "Show more" — theme-customizer
     driven (settings.kl_reviews_per_page, injected as window.GF_KLAVIYO_REVIEWS
     in theme.liquid). Also the page size for each "Show more" click. */
  var PAGE_SIZE = (window.GF_KLAVIYO_REVIEWS && window.GF_KLAVIYO_REVIEWS.perPage) || 8;

  /* Pagination state for the custom-rendered list. lastFull tracks whether the
     last fetched page returned a full PAGE_SIZE (a short page means no more). */
  var state = { productId: null, sort: DEFAULT_SORT, loaded: 0, total: 0, lastFull: false };

  function getProductId() {
    var el = document.getElementById('fulfilled-reviews-all');
    return el && el.getAttribute('data-id');
  }

  function getList() {
    var wrapper = document.getElementById('klaviyo-product-reviews-wrapper');
    return wrapper && wrapper.querySelector('#reviewslist .kl_reviews__list_container');
  }

  function fetchReviews(productId, sort, offset) {
    var url = 'https://fast.a.klaviyo.com/reviews/api/client_reviews/' + productId
      + '/?product_id=' + productId + '&company_id=' + COMPANY_ID
      + '&limit=' + PAGE_SIZE + '&offset=' + (offset || 0) + '&sort=' + sort + '&filter=&type=reviews&media=false';
    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function formatTime(iso) {
    if (!iso) return '';
    var then = new Date(iso).getTime();
    var diff = Math.max(0, Date.now() - then);
    var day = 86400000;
    var days = Math.floor(diff / day);
    if (days < 1) return 'today';
    if (days < 7) return days + ' day' + (days === 1 ? '' : 's') + ' ago';
    if (days < 30) {
      var w = Math.floor(days / 7);
      return w + ' week' + (w === 1 ? '' : 's') + ' ago';
    }
    if (days < 365) {
      var m = Math.floor(days / 30);
      return m + ' month' + (m === 1 ? '' : 's') + ' ago';
    }
    var y = Math.floor(days / 365);
    return y + ' year' + (y === 1 ? '' : 's') + ' ago';
  }

  function escapeHTML(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function renderStars(rating) {
    /* Layered unicode stars matching the summary histogram. */
    var pct = Math.max(0, Math.min(5, Number(rating) || 0)) / 5 * 100;
    return '<span class="gf-reviews-stars gf-reviews-stars--inline">'
      + '<span class="gf-reviews-stars__bg" aria-hidden="true">★★★★★</span>'
      + '<span class="gf-reviews-stars__fg" aria-hidden="true" style="width:' + pct + '%">★★★★★</span>'
      + '</span>';
  }

  function renderVerified() {
    return '<span class="kl_reviews__review__verified">'
      + '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">'
      /* Badge matches the filled-star color (--kl-text). Set inline so it beats
         Klaviyo's runtime-injected stylesheet (which loads after ours and would
         otherwise win the cascade on this selector). */
      + '<circle cx="12" cy="12" r="10" style="fill: var(--kl-text, #35382e)"/>'
      + '<path d="M7.5 12.5l3 3 6-6.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg>'
      + '<span>Verified buyer</span>'
      + '</span>';
  }

  function renderFitSlider(answerValue) {
    /* answerValue is "1" / "2" / "3" → left, center, right */
    var positions = { '1': '0%', '2': '50%', '3': '100%' };
    var pos = positions[String(answerValue)] || '50%';
    return '<span>'
      + '<svg width="100%" height="16" viewBox="0 0 200 16" preserveAspectRatio="none" aria-hidden="true">'
      + '<rect x="0" y="6" width="200" height="3" rx="1.5" fill="currentColor" opacity="0.2"/>'
      + '<circle cx="' + (pos === '0%' ? 4 : pos === '50%' ? 100 : 196) + '" cy="7.5" r="4" fill="currentColor"/>'
      + '</svg>'
      + '</span>';
  }

  function renderAttributes(qa) {
    if (!qa) return '';
    var textPairs = [], rangePairs = [];
    Object.keys(qa).forEach(function (k) {
      var q = qa[k];
      if (!q) return;
      var ansArr = Array.isArray(q.answer) ? q.answer : [q.answer];
      if (q.type === 'centered_range') {
        rangePairs.push({ q: q, ans: ansArr[0] });
      } else if (q.type === 'single_select' || q.type === 'multi_select' || q.type === 'text') {
        textPairs.push({ q: q, ans: ansArr.filter(Boolean).join(', ') });
      }
    });

    var html = '';
    if (textPairs.length) {
      html += '<div class="kl_reviews__review__attributes">';
      textPairs.forEach(function (p) {
        html += '<div class="kl_reviews__custom_question_answer">'
          + '<strong class="kl_reviews__custom_question__question--text">' + escapeHTML(p.q.label) + '</strong>'
          + '<span class="kl_reviews__custom_question__answer--text"><span>' + escapeHTML(p.ans) + '</span></span>'
          + '</div>';
      });
      html += '</div>';
    }
    if (rangePairs.length) {
      html += '<div class="kl_reviews__review__attributes">';
      rangePairs.forEach(function (p) {
        html += '<div class="kl_reviews__custom_question_answer">'
          + '<strong class="kl_reviews__custom_question__question--range">' + escapeHTML(p.q.label) + '</strong>'
          + renderFitSlider(p.ans)
          + '<div class="kl_reviews__custom_question__answer--range">'
          + '<span>' + escapeHTML(p.q.values?.min || '') + '</span>'
          + '<span>' + escapeHTML(p.q.values?.center || '') + '</span>'
          + '<span>' + escapeHTML(p.q.values?.max || '') + '</span>'
          + '</div>'
          + '</div>';
      });
      html += '</div>';
    }
    return html;
  }

  function renderReviewItem(r) {
    var title = r.title ? '<div class="kl_reviews__review__title">' + escapeHTML(r.title) + '</div>' : '<div class="kl_reviews__review__title"></div>';
    return '<div class="kl_reviews__review_item">'
      + '<div>'
      + '<div class="kl_reviews__review_stars_and_time">'
      + '<div><div class="kl_reviews__stars_badge">' + renderStars(r.rating) + '</div></div>'
      + '<div class="kl_reviews__time_badge"><div class="kl_reviews__review__timestamp">' + escapeHTML(formatTime(r.created_at)) + '</div></div>'
      + '</div>'
      + '<div>'
      + title
      + '<div class="kl_reviews__review__author">'
      + '<div>' + escapeHTML(r.author || 'Anonymous') + '</div>'
      + (r.verified ? renderVerified() : '')
      + '</div>'
      + '<p class="kl_reviews__review__content">' + escapeHTML(r.content || '') + '</p>'
      + '</div>'
      + renderAttributes(r.question_answers)
      + '</div>'
      + '</div>';
  }

  /* Show-more button lives as a sibling after .kl_reviews__list_container so it
     survives the list's innerHTML replacement on (re)render. Shown only while
     more reviews remain (loaded < total) and the last page came back full. */
  function updateShowMore() {
    var list = getList();
    if (!list) return;
    var container = list.parentElement;
    var wrap = container.querySelector('.gf-reviews-show-more-wrap');
    var more = state.loaded < state.total && state.lastFull;
    if (more) {
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'gf-reviews-show-more-wrap';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gf-reviews-show-more';
        btn.textContent = 'Show more reviews';
        btn.addEventListener('click', function () { appendPage(btn); });
        wrap.appendChild(btn);
        container.appendChild(wrap);
      } else {
        var b = wrap.querySelector('.gf-reviews-show-more');
        if (b) { b.disabled = false; b.textContent = 'Show more reviews'; }
        container.appendChild(wrap); /* keep it last, after the list */
      }
    } else if (wrap) {
      wrap.remove();
    }
  }

  /* Replace the list with the first page for the given sort, then sync the
     Show-more button. */
  function renderList(sort) {
    var list = getList();
    if (!list) return;
    state.sort = sort;
    list.classList.add('gf-reviews-sort__loading');
    fetchReviews(state.productId, sort, 0).then(function (data) {
      list.classList.remove('gf-reviews-sort__loading');
      if (!data || !data.reviews) return;
      list.innerHTML = data.reviews.map(renderReviewItem).join('');
      state.loaded = data.reviews.length;
      state.total = (data.summary && data.summary.review_count) || data.reviews.length;
      state.lastFull = data.reviews.length === PAGE_SIZE;
      updateShowMore();
    });
  }

  /* Append the next page (same sort) to the existing list. */
  function appendPage(btn) {
    var list = getList();
    if (!list) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Loading…'; }
    fetchReviews(state.productId, state.sort, state.loaded).then(function (data) {
      if (data && data.reviews && data.reviews.length) {
        list.insertAdjacentHTML('beforeend', data.reviews.map(renderReviewItem).join(''));
        state.loaded += data.reviews.length;
        state.lastFull = data.reviews.length === PAGE_SIZE;
      } else {
        state.lastFull = false;
      }
      updateShowMore();
    });
  }

  function buildDropdown() {
    var wrap = document.createElement('div');
    wrap.className = 'gf-reviews-sort';
    wrap.innerHTML = ''
      + '<label class="gf-reviews-sort__label" for="gf-reviews-sort">Sort:</label>'
      + '<select id="gf-reviews-sort" class="gf-reviews-sort__select">'
      + SORT_OPTIONS.map(function (o) {
        return '<option value="' + o.value + '"' + (o.value === DEFAULT_SORT ? ' selected' : '') + '>'
          + escapeHTML(o.label) + '</option>';
      }).join('')
      + '</select>';

    wrap.querySelector('select').addEventListener('change', function (e) {
      renderList(e.target.value);
    });

    return wrap;
  }

  function tryInject() {
    var wrapper = document.getElementById('klaviyo-product-reviews-wrapper');
    if (!wrapper) return false;
    var tabsRow = wrapper.querySelector('.kl_reviews__list__tabs');
    if (!tabsRow) return false;
    if (tabsRow.dataset.gfSortInjected) return true;

    var productId = getProductId();
    if (!productId) return true;
    tabsRow.dataset.gfSortInjected = '1';
    state.productId = productId;

    var dropdown = buildDropdown();
    var tabButtons = tabsRow.querySelector('.kl_reviews__list__tab_buttons');
    if (tabButtons) {
      tabsRow.insertBefore(dropdown, tabButtons);
    } else {
      tabsRow.appendChild(dropdown);
    }

    /* Rewrite the "Reviews <small>N</small>" tab to plain "N reviews" text
       so the left side matches z-supply's review-count label. */
    var tab = tabsRow.querySelector('.kl_reviews__list__tab');
    if (tab) {
      var count = (tab.querySelector('small') || {}).textContent || tab.textContent.replace(/\D/g, '');
      tab.textContent = (count || '0') + ' review' + (count === '1' ? '' : 's');
    }

    wrapper.classList.add('gf-reviews-has-sort');

    /* Always render the first page ourselves so the configurable page size and
       the Show-more button apply. Klaviyo's own initial render uses sort=3 with
       no page cap; this replaces it with PAGE_SIZE reviews at DEFAULT_SORT. */
    renderList(DEFAULT_SORT);

    return true;
  }

  function bootstrap() {
    if (tryInject()) return;
    var attempts = 0;
    var iv = setInterval(function () {
      if (tryInject() || ++attempts > 50) clearInterval(iv);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
